import { render, staticRenderFns } from "./freeLogin.vue?vue&type=template&id=52f85dda&scoped=true"
import script from "./freeLogin.vue?vue&type=script&lang=js"
export * from "./freeLogin.vue?vue&type=script&lang=js"
import style0 from "./freeLogin.vue?vue&type=style&index=0&id=52f85dda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f85dda",
  null
  
)

export default component.exports